import { useSetupGuideState } from '~/presentation/common/components/GSetupGuide/useSetupGuideState';
import { useUserActionHandlers } from '~/hooks/useUserActionHandlers';
import { URL_REDIRECT_SETUP_GUIDE_SEEN_ACTION } from '../constants';
import { EPersistKey } from '~/types/persist';
import { useEffectRunOnce } from '~/hooks';
import { useCallback } from 'react';

interface IProps {
  isReady: boolean;
}

export const useUrlRedirectSetupGuideFirstVisit = ({ isReady }: IProps): void => {
  const { setShowSetupGuide } = useSetupGuideState();
  const { actions, hasActionTypeInStore, setUserActionBy } = useUserActionHandlers({
    persistKey: EPersistKey.SETUP_GUIDE_URL_REDIRECT_SEEN,
  });

  const handleFirstVisit = useCallback(() => {
    const hasSeenSetupGuide = actions?.[URL_REDIRECT_SETUP_GUIDE_SEEN_ACTION] === 'true';
    setUserActionBy(URL_REDIRECT_SETUP_GUIDE_SEEN_ACTION, 'true');

    if (hasSeenSetupGuide) return;

    setShowSetupGuide();
  }, [actions, setUserActionBy, setShowSetupGuide]);

  useEffectRunOnce(handleFirstVisit, isReady && hasActionTypeInStore);
};
